if (!customElements.get('selling-plan')) {
  class SellingPlan extends HTMLElement {
    constructor() {
      super();

      this.cartItems = this.closest('cart-drawer-items') || this.closest('cart-items');
      this.checkboxEl = this.querySelector('[data-cart-item-subscription]');
      this.sellingPlanContainer = document.getElementById(this.checkboxEl.getAttribute('aria-controls'));
      this.sellingPlanEl = this.querySelector('[data-cart-item-selling-plan]');
      this.quantityInput = this.closest('.cart-item').querySelector('.quantity__input');
      this.defaultSellingPlan = this.checkboxEl.dataset.defaultSellingPlan;

      if (!this.checkboxEl || !this.sellingPlanContainer || !this.sellingPlanEl) return;

      let selected = this.sellingPlanEl.querySelector('option');
      const params = new URLSearchParams(window.location.search);
      const sellingPlan = params.get('selling_plan');
      this.handleCheckboxChange = this.onCheckboxChange.bind(this);
      this.handleSellingPlanChange = this.onSellingPlanChange.bind(this);
      

      Select.bind(this.sellingPlanEl);

      this.subscription = this.checkboxEl.checked
    }

    connectedCallback() {
      this.addEventListeners()
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }
    
    addEventListeners() {
      this.checkboxEl.addEventListener('change', this.handleCheckboxChange);
      this.sellingPlanEl.addEventListener('change', this.handleSellingPlanChange);
    }

    removeEventListeners() {
      this.checkboxEl.removeEventListener('change', this.handleCheckboxChange);
      this.sellingPlanEl.removeEventListener('change', this.handleSellingPlanChange);
    }

    onCheckboxChange(e) {
      if (e.currentTarget.checked) {
        this.sellingPlanContainer.setAttribute('aria-hidden', 'false');
        this.checkboxEl.setAttribute('aria-expanded', 'true');
        this.updateSellingPlan(this.dataset.index, this.defaultSellingPlan, this.quantityInput.value, document.activeElement.getAttribute('name'));
      } else {
        this.sellingPlanContainer.setAttribute('aria-hidden', 'true');
        this.checkboxEl.setAttribute('aria-expanded', 'false');
        this.updateSellingPlan(this.dataset.index, null, this.quantityInput.value, document.activeElement.getAttribute('name'));
      }
    }

    onSellingPlanChange(e) {
      this.updateSellingPlan(this.dataset.index, e.currentTarget.value, this.quantityInput.value, document.activeElement.getAttribute('name'));
    }

    updateSellingPlan(line, selling_plan, quantity, name) {
      this.cartItems.enableLoading(line);

      const body = JSON.stringify({
        line,
        selling_plan,
        quantity,
        sections: this.cartItems.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
  
          this.cartItems.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
              this.cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));
  
          const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
          }
          this.cartItems.disableLoading();
        }).catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
          this.cartItems.disableLoading();
        });
    }
  }

  customElements.define('selling-plan', SellingPlan);
}
